var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPbIconPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-847.000000, -457.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 863,
    cy: 473,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863,457 C871.836556,457 879,464.163444 879,473 C879,481.836556 871.836556,489 863,489 C854.163444,489 847,481.836556 847,473 C847,464.163444 854.163444,457 863,457 Z M860,467 L858,467 C857.447715,467 857,467.447715 857,468 L857,468 L857,478 C857,478.552285 857.447715,479 858,479 L858,479 L860,479 C860.552285,479 861,478.552285 861,478 L861,478 L861,468 C861,467.447715 860.552285,467 860,467 L860,467 Z M868,467 L866,467 C865.447715,467 865,467.447715 865,468 L865,468 L865,478 C865,478.552285 865.447715,479 866,479 L866,479 L868,479 C868.552285,479 869,478.552285 869,478 L869,478 L869,468 C869,467.447715 868.552285,467 868,467 L868,467 Z",
    id: "Combined-Shape",
    fill: "#CC0FE0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbIconPause);
export default __webpack_public_path__ + "static/media/pbIconPause.fccca9f9.svg";
export { ForwardRef as ReactComponent };